//@flow
import React from 'react';
import Link from '../../../components/Link';

type Props = {
  label:string,
  link:string,
};

export default function MobileMenuListItem(props:Props) {
  const {link, label} = props;
  return (
    <li role="menuitem">
      <Link to={link}>
        {label}
      </Link>
    </li>
  );
}
